import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Lock, CheckCircle } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error('Minimum 6 caractères'); return; }
    if (password !== confirm) { toast.error('Les mots de passe ne correspondent pas'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/reset-password`, { token, new_password: password });
      setDone(true);
      toast.success('Mot de passe mis à jour !');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Lien invalide ou expiré');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <Card className="w-full max-w-md text-center p-8">
          <p className="text-red-500 font-medium">Lien invalide. Aucun token de réinitialisation trouvé.</p>
          <Button onClick={() => navigate('/forgot-password')} className="mt-4">Demander un nouveau lien</Button>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white flex items-center justify-center px-4">
      <Card className="w-full max-w-md" data-testid="reset-password-card">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Nouveau mot de passe</CardTitle>
          <p className="text-muted-foreground text-sm mt-2">Choisissez un nouveau mot de passe</p>
        </CardHeader>
        <CardContent>
          {done ? (
            <div className="text-center space-y-4 py-4" data-testid="reset-success">
              <CheckCircle className="w-12 h-12 text-green-500 mx-auto" />
              <p className="font-medium">Mot de passe mis à jour !</p>
              <Button onClick={() => navigate('/login')} className="btn-primary">Se connecter</Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label>Nouveau mot de passe</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-3 w-4 h-4 text-muted-foreground" />
                  <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)}
                    placeholder="Min. 6 caractères" className="pl-10" data-testid="new-password-input" />
                </div>
              </div>
              <div>
                <Label>Confirmer</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-3 w-4 h-4 text-muted-foreground" />
                  <Input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                    placeholder="Confirmez le mot de passe" className="pl-10" data-testid="confirm-password-input" />
                </div>
              </div>
              <Button type="submit" className="w-full btn-primary" disabled={loading} data-testid="reset-submit-btn">
                {loading ? 'Mise à jour...' : 'Mettre à jour'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
